import React from 'react';

interface SearchBarProps {
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
}

const SearchBar: React.FC<SearchBarProps> = ({ value, onChange, placeholder }) => (
  <input
    type="text"
    value={value}
    onChange={e => onChange(e.target.value)}
    placeholder={placeholder}
    autoComplete="off"
    style={{ 
      width: 400, 
      padding: '11px 14px', 
      border: '1px solid #cbd5e1', 
      borderRadius: 6,
      fontSize: 15,
      outline: 'none',
      boxSizing: 'border-box',
      transition: 'border-color 0.2s'
    }}
  />
);

export default SearchBar; 